module.exports = __webpack_public_path__ + "static/img/logo.a785bd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 4